// Classification des réponses entrantes (spec 05.6) par mots-clés, FR, arabe et darija
// tunisienne (graphie arabe et latine). Le classifieur LLM (BA-061) ne vient qu'en second
// avis sur les réponses `question`. Pure et sans I/O.

export type InboundIntent = 'stop' | 'paid_elsewhere' | 'later' | 'question';

/** Boutons WhatsApp des modèles (spec 06). */
const BUTTONS: Record<string, InboundIntent> = {
  ALREADY_PAID: 'paid_elsewhere',
  LATER: 'later',
  STOP: 'stop',
};

/** Mot entier, accents compris (la limite de mot ASCII de JavaScript ignore les lettres accentuées). */
const word = (source: string) => new RegExp(`(?<!\\p{L})(?:${source})(?!\\p{L})`, 'iu');

const PATTERNS: [InboundIntent, RegExp[]][] = [
  [
    'stop',
    [
      /^\s*(stop|stopp?e?|arr[eê]t(e|ez)?|desinscri(re|ption)|d[ée]sabonn(er|ement))\s*[.!]*\s*$/i,
      word('ne plus (me )?(contacter|envoyer|recevoir)|plus de messages?'),
      /^\s*(بطل|بركة|توقف|ايقاف|إيقاف|stop)\s*[.!]*\s*$/u,
      /(لا ترسل|ما عادش تبعث|ما تبعثليش)/u,
    ],
  ],
  [
    'paid_elsewhere',
    [
      word(
        "d[ée]j[aà] pay[ée]e?|j'?ai (d[ée]j[aà] )?(pay[ée]|r[ée]gl[ée])|c'?est (pay[ée]|r[ée]gl[ée])|pay[ée] en agence|r[ée]gl[ée]",
      ),
      word('khallast|5allast|khlast|5lasst?'),
      /(خلصت|دفعت|خلّصت|تم الدفع|خالص)/u,
    ],
  ],
  [
    'later',
    [
      word(
        'plus tard|la semaine prochaine|semaine pro|demain|le mois prochain|fin du mois|apr[eè]s',
      ),
      word('ba3d|ghodwa|8odwa'),
      /(بعد|غدوة|غدا|الجمعة الجاية|الشهر الجاي|آخر الشهر)/u,
    ],
  ],
];

export function classifyInbound(body: string, buttonPayload?: string | null): InboundIntent {
  if (buttonPayload && BUTTONS[buttonPayload.toUpperCase()])
    return BUTTONS[buttonPayload.toUpperCase()] as InboundIntent;
  const text = body.normalize('NFC').trim();
  for (const [intent, patterns] of PATTERNS) {
    if (patterns.some((p) => p.test(text))) return intent;
  }
  return 'question';
}
